import React from 'react';
import { CollapsePanelProps } from 'antd';
import { Panel as PanelComponent } from './styles';

const Panel: React.FC<CollapsePanelProps> = ({
    header,
    key,
    children,
    ...rest
}) => {
    return (
        <PanelComponent header={header} key={key} {...rest}>
            {children}
        </PanelComponent>
    );
};

export default Panel;
